import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateFilters } from "../../../data/account/actions/quotation";
import { isEmpty } from "lodash";
import { useTranslation } from "react-i18next";
import { unloadQuotations } from "../../../data/account/actions/quotation";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";
import TripCardsList from "../../account/components/TripCardsList";
import NewTripLight from "../../account/components/NewTripLight";
import {getQuotations} from "../../../data/account/selectors/quotation";

export default function HomeBusiness() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isFetching, entities } = useSelector(state => state.account.quotation);
    const isDeleting = useSelector(state => state.followup.followup.isDeleting);
    const [filteredPending, setfilteredPending] = useState([]);
    const [filteredDraft, setfilteredDraft] = useState([]);

    let quotations = getQuotations(entities);

    useEffect(() => {
        dispatch(unloadQuotations());
        dispatch(updateFilters({ status: ["draft", "pending_quotation", "pending_customer_confirmation"] }))
    }, [])

    useEffect(() => {
        let quotationDraft = [];
        let quotationPending = [];
        if (quotations) {
            quotations.forEach(element => {
                if (element.status == "draft") {
                    quotationDraft.push(element);
                }
                else {
                    quotationPending.push(element)
                }
            });
        }
        setfilteredDraft(quotationDraft);
        setfilteredPending(quotationPending);
    }, [entities.quotations])

    return (
        <>
            <div className={"space-y-16"}>
                <NewTripLight />
                {isFetching ?
                    < div className={"space-y-16"}>
                        <div className="h-[50vh] overflow-hidden flex justify-center items-center">
                            <FontAwesomeIcon icon={faCircleNotch} className={"h-10 w-10 text-gray-300 self-center"} spin />
                            <p className="ml-4 text-lg text-gray-800">{t('shared.loading')}...</p>
                        </div>
                    </div>
                    : <>
                        {!isEmpty(filteredDraft) && <div>
                            <h2 className={"mb-4 text-lg font-semibold"}>
                                {t('booking.status_quotation_drafts')}{' '}
                                {(isDeleting || isFetching) && <FontAwesomeIcon icon={faCircleNotch} spin />}
                            </h2>
                            <TripCardsList
                                trips={filteredDraft}
                                editable={true}
                                isLoading={isDeleting}
                                business={true}
                            />
                        </div>}
                        {!isEmpty(filteredPending) && <div>
                            <h2 className={"mb-4 text-lg font-semibold"}>{t('booking.pending_requests')}</h2>
                            <TripCardsList
                                trips={filteredPending}
                                editable={false}
                                isLoading={isDeleting}
                                business={true}
                            />
                        </div>}
                    </>}
            </div >
        </>
    );
}
